var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 17.625V12.75H8.95312C8.75421 12.75 8.56345 12.671 8.4228 12.5303C8.28214 12.3897 8.20312 12.1989 8.20312 12C8.20312 11.8011 8.28214 11.6103 8.4228 11.4697C8.56345 11.329 8.75421 11.25 8.95312 11.25H15.75V6.375C15.7493 5.67904 15.4725 5.01179 14.9803 4.51967C14.4882 4.02755 13.821 3.75074 13.125 3.75H4.125C3.42904 3.75074 2.76179 4.02755 2.26967 4.51967C1.77755 5.01179 1.50074 5.67904 1.5 6.375V17.625C1.50074 18.321 1.77755 18.9882 2.26967 19.4803C2.76179 19.9725 3.42904 20.2493 4.125 20.25H13.125C13.821 20.2493 14.4882 19.9725 14.9803 19.4803C15.4725 18.9882 15.7493 18.321 15.75 17.625Z",
    fill: "#773ADA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9392 12.7501L17.4698 15.2199C17.3351 15.3617 17.2611 15.5505 17.2636 15.7461C17.2661 15.9417 17.3449 16.1285 17.4832 16.2668C17.6215 16.4051 17.8084 16.4839 18.004 16.4864C18.1995 16.4889 18.3884 16.415 18.5302 16.2802L22.2802 12.5302C22.4207 12.3896 22.4997 12.1989 22.4997 12.0001C22.4997 11.8013 22.4207 11.6106 22.2802 11.4699L18.5302 7.71994C18.3884 7.58522 18.1995 7.51123 18.004 7.51373C17.8084 7.51624 17.6215 7.59504 17.4832 7.73334C17.3449 7.87164 17.2661 8.0585 17.2636 8.25407C17.2611 8.44964 17.3351 8.63845 17.4698 8.78025L19.9392 11.2501H15.75V12.7501H19.9392Z",
    fill: "#773ADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.c26a0650.svg";
export { ForwardRef as ReactComponent };